import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '@/components/shared/PageContainer';
import { queryClient } from '@/lib/utils/queryClient';
import { CreateSsoOrganizationDialog } from '../-components/CreateSsoOrganizationDialog';
import { SsoOrganizationsTable } from '../-components/SsoOrganizationsTable';
import { ssoOrganizationsQueryOptions } from '../-hooks/useSsoOrganizations';
import { useSsoOrganizationsPage } from '../-hooks/useSsoOrganizationsPage';

/**
 * Native SSO: the companies whose users sign in with their identity provider.
 * See `docs/AUTH_GUIDE.md` (SSO).
 */
export const Route = createFileRoute('/management/sso/(pages)/')({
  // A prefetch: a failure here must not hide the table's own error banner.
  loader: () =>
    queryClient
      .ensureQueryData(ssoOrganizationsQueryOptions())
      .catch(() => undefined),
  component: SsoOrganizationsPage,
});

function SsoOrganizationsPage() {
  const page = useSsoOrganizationsPage();

  return (
    <PageContainer>
      <SsoOrganizationsTable page={page} />
      <CreateSsoOrganizationDialog page={page} />
    </PageContainer>
  );
}
